import { QUANTITY_OPTIONS } from '../constants/Cards';
import FeatureFlags from '../../util/featureFlags';

// eslint-disable-next-line import/prefer-default-export
export function getQuantityOptionsFromProjectMeta(projectMeta, maxQty = 400) {
  let quantityOptions;

  if (
    FeatureFlags.get('invitesDynamicReviewMinimumQuantity') &&
    projectMeta &&
    typeof projectMeta.minimum_quantity === 'number'
  ) {
    quantityOptions = [];

    const minQty = projectMeta.minimum_quantity;
    for(let i = minQty; i <= maxQty; i += 10) {
      quantityOptions.push({ label: i.toString(), value: i });
    }
  } else {
    quantityOptions = QUANTITY_OPTIONS;
  }

  return quantityOptions;
}



// WEBPACK FOOTER //
// ./src/cards/util/minQuantityHelper.js